// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"908ba549","856":"68e13c4a"}[chunkId] + ".js";
};